module.exports = __webpack_public_path__ + "img/Untitled.3eab758c.png";